import { AbilityBuilder, Ability, AbilityClass } from "@casl/ability";
import { auth } from "../store/authModule";

type Actions = "view";

type AdministrationObjects = "Users" | "Roles";

type Objects =
  | "Administration"
  | AdministrationObjects
  | "Catalogues"
  | "Documents"
  | "Settings";

export type Policy = number;

export interface PolicyPermission {
  policy: Policy;
  permission: string;
}

export interface CompoundPermission {
  permission: Objects;
  depentent: Objects[];
}

export const mapPolicyPermission: Map<number, Objects> = new Map<
  number,
  Objects
>([
  [1, "Users"],
  [2, "Roles"],
  [3, "Catalogues"],
  [4, "Documents"],
  [5, "Settings"],
]);

export const compoundPermissions: CompoundPermission[] = [
  {
    permission: "Administration",
    depentent: ["Users", "Roles"],
  },
];

export type AppAbility = Ability<[Actions, Objects]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;
let ability: AppAbility;

export function defineRulesFor(policies: Policy[]) {
  const { can, rules } = new AbilityBuilder(AppAbility);

  //добавляем составные разрешения
  compoundPermissions
    .filter(
      (p) =>
        p.depentent.filter((x: string) =>
          policies.some((y) => mapPolicyPermission.get(y) == x)
        ).length
    )
    .forEach((p) => can("view", p.permission));

  //добавляем разрешения
  policies.forEach((p: Policy) => can("view", mapPolicyPermission.get(p)));

  return rules;
}

export function getAppAbility() {
  ability = new AppAbility(
    defineRulesFor(auth.getters.getPolicies(auth.state))
  );
  return ability;
}

export function updateAppAbility() {
  ability.update(defineRulesFor(auth.getters.getPolicies(auth.state)));
}
